import "reflect-metadata";
import Vue from "vue";
//import './plugins/vuetify'
import App from "./App.vue";
import router from "./router";
import store from "./store";
import ApiService from "./services/api.service";
import AuthService from "./services/auth.service";
import SettingsService from "./services/settings.service";
import VueLogger from "vuejs-logger";
//import Vuetify from 'vuetify'
import "@mdi/font/css/materialdesignicons.css";
import { i18n } from "@/plugins/i18n";
import FlagIcon from "vue-flag-icon";
import "./plugins";
import vuetify from "@/plugins/vuetify";
import { sync } from "vuex-router-sync";
import money from "v-money";
import DatetimePicker from "vuetify-datetime-picker";
import rules from "./plugins/validation";
import exportersInstaller from "./plugins/exporters";
import axios from "axios";
import Papa from "papaparse";
// import { ListBoxPlugin } from "@syncfusion/ej2-vue-dropdowns";
import VueQuillEditor from "vue-quill-editor";
import "quill/dist/quill.core.css"; // import styles
import "quill/dist/quill.snow.css"; // for snow theme

import "vue-context/dist/css/vue-context.css";
import "./plugins/vuetify-money.js";
import helpers from "./plugins/helpers.js";
import files from "./plugins/files.js"
import VCurrencyField from "v-currency-field";

import { VTextField } from "vuetify/lib";
import VueCompositionAPI from "@vue/composition-api";
sync(store, router);
Vue.config.productionTip = false;

SettingsService.init().then(async () => {
  const parsed = await import("./translations.csv");
  i18n.setLocaleMessage(
    "en",
    Object.keys(parsed)
      .map((i) => ({ [parsed[i][0]]: parsed[i][1] }))
      .reduce(function (result, current) {
        return Object.assign(result, current);
      }, {}),
  );
  i18n.setLocaleMessage(
    "fr",
    Object.keys(parsed)
      .map((i) => ({ [parsed[i][0]]: parsed[i][2] }))
      .reduce(function (result, current) {
        return Object.assign(result, current);
      }, {}),
  );

  const actualConsoleLog = window.console.log;
  let logs = {};
  // window.console.log = (...args) => {
  //     let key = 'undefined';
  //     if (args.length > 1 && typeof args[0] === 'string') {
  //         key = args.shift();
  //     }

  //     if (logs[key]) {
  //         logs[key].push(args);
  //     } else {
  //         logs[key] = [args];
  //     }
  // };

  // window.console.flush = () => {
  //     console.clear();
  //     for (var key of Object.keys(logs)) {
  //         console.groupCollapsed(key);
  //         for (var log of logs[key]) {
  //             actualConsoleLog(...log);
  //         }
  //         console.groupEnd();
  //     }
  // }
  // window.console.flushClear = () => {
  //     window.console.flush();
  //     logs = {};
  // };

  // console.log(JSON.stringify(Object.keys(parsed).map((i) => ({ [parsed[i][0]]: parsed[i][2] })).reduce(function (result, current) {
  //     return Object.assign(result, current);
  // }), {}));

  var settings = SettingsService.settings;

  // Set the base URL of the API
  ApiService.init(settings);
  exportersInstaller(settings.APIURL + "excel/");
  AuthService.init(settings);
  store._actions["common/setSettings"][0](settings);

  const isProduction = process.env.NODE_ENV === "production";

  const options = {
    isEnabled: true,
    logLevel: isProduction ? "error" : "debug",
    stringifyArguments: false,
    showLogLevel: true,
    showMethodName: true,
    separator: "|",
    showConsoleColors: true,
  };
  /*Vue.use(Vuetify, {
      iconfont: 'mdi'
    })*/
  Vue.component("v-text-field", VTextField);
  // Vue.use(ListBoxPlugin);
  Vue.use(VueQuillEditor /* { default global options } */);
  Vue.use(VueLogger, options);
  Vue.use(FlagIcon);
  Vue.use(money, { precision: 4 });
  Vue.use(DatetimePicker);
  Vue.use(rules);
  Vue.use(helpers);
  Vue.use(files);
  Vue.use(VCurrencyField, {
    locale: "en-ca",
    decimalLength: 2,
    autoDecimalMode: true,
    min: null,
    max: null,
    defaultValue: 0,
    valueAsInteger: false,
    allowNegative: true,
  });
  Vue.use(VueCompositionAPI);
  Vue.filter("toCurrency", function (value) {
    if (typeof value !== "number") {
      return value;
    }
    var formatter = new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: "USD",
      minimumFractionDigits: 2,
    });
    return formatter.format(value);
  });


  new Vue({
    i18n,
    router,
    store,
    vuetify,
    render: (h) => h(App),
  }).$mount("#app");
});
